import { lazy } from "react"

export const OrderLogsById = lazy(() => import("./OrderLogsById"))